import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppButton, AppInput } from '../../../shared/forms/components';
import AppDropdown from '../../../shared/forms/components/AppDropDown/AppDropDown.component';
import { User } from '../../../models/user';
import { getUserList } from '../../../app/redux/appSelector';
import { RootState } from '../../../app/redux/rootReducer';
import { CreateWorkshop } from '../../../models/workshop';
import { organizationActions } from '../../dashboard/redux/organizationSlice';

const getInitialValues = (workshop: CreateWorkshop) => ({
  ...workshop,
});

const validationSchema = Yup.object().shape({
  workshopName: Yup.string().required(),
  responsibleUserId: Yup.string(),
});

interface Props {
  categoryId: string;
  state: RootState;
  sectionId: string;
  users: Array<User>;
  createWorkshop: (workshop: CreateWorkshop) => void;
  onSubmit?: () => void;
}

const CreateWorkshopForm: React.FC<Props> = ({
  categoryId,
  sectionId,
  onSubmit,
  users,
  createWorkshop,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const getUsersOptions = () =>
    users.map((user) => (
      <option key={user.userId} value={user.userId}>
        {user.email}
      </option>
    ));

  const onSubmitHandler = (values: CreateWorkshop) => {
    onSubmit && onSubmit();
    createWorkshop(values);
  };

  return (
    <Formik
      initialValues={getInitialValues({
        categoryId: categoryId,
        sectionId: sectionId,
        workshopName: '',
        responsibleUserId: '',
      })}
      onSubmit={onSubmitHandler}
      validationSchema={validationSchema}
    >
      {({ values }) => (
        <Form>
          <AppInput
            name="workshopName"
            label="Workshop Name*"
            placeholder="Enter Workshop Name"
            type="text"
            loading={isLoading}
          />
          <AppDropdown
            name="responsibleUserId"
            label="Responsible User"
            placeholder="Responsible User"
            loading={isLoading}
          >
            <option defaultChecked value="">
              Unassigned
            </option>
            {getUsersOptions()}
          </AppDropdown>
          <AppButton type="submit" text="Create" loading={isLoading} />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state: RootState) => ({
  state,
  users: getUserList(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createWorkshop: (workshop: CreateWorkshop) => {
    dispatch(organizationActions.createWorkshop(workshop));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateWorkshopForm);
